define([
    'vue',
    'web/i18n/index',
    'WebCommon/mixin/page',
    'vueRouter',
    'download/component/main',


    'css!download/download.css'
], function(
    Vue,
    i18n,
    PageMixin,
    VueRouter,
    PageContent
){
    Vue.use(VueRouter);

    var routes = [
        { path: '*', component: PageContent }
    ];
    var router = new VueRouter({
        routes: routes,
        mode: 'history',
        base: '/'
    });

    var app = new Vue({
        mixins: [PageMixin],
        router: router,
        i18n: i18n
    });
    app.$mount('#app');
});



//////////////////
// WEBPACK FOOTER
// ./download/download.js
// module id = 349
// module chunks = 8